export function isUrlExternal(url: string) {
  // хак, чтобы не использовать компонент `Link` из гетсби для битых ссылок
  if (!url) {
    return true;
  }

  if ((url.startsWith('http') && url.includes('://')) || url.startsWith('mailto')) {
    return true;
  }

  return false;
}
